import { render, staticRenderFns } from "./return-aside.vue?vue&type=template&id=3264f024&"
import script from "./return-aside.vue?vue&type=script&lang=js&"
export * from "./return-aside.vue?vue&type=script&lang=js&"
import style0 from "./return-aside.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports